module.exports = __webpack_public_path__ + "img/case-tab-bg-02.aff7665f.jpg";